// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"9ce56c42","57":"c35ef5d2","353":"dd410850","449":"c36c97d6","453":"87e45203","660":"dff304d2","697":"d53a2ee7","712":"b2b2252e","819":"00b8f9ac","885":"78592424","919":"67a39625"}[chunkId] + ".chunk.js";
};